import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';

import { IPlanState, PlanSummaryMap } from '../..';
import { PlansState } from './plans.state';

/**
 * Moving forward, this is the pattern we should consume.
 * This abstracts the selectors from the main state object,
 * it's more readable and allows better abstraction.
 *
 * NOTE: The selectors defined here should be selectors that are
 * consumed by many features. If it's only consumed by one feature,
 * add a selector that is feature specific. If the selector depends
 * on data from other state objects, should also be a facade somewhere else.
 */
@Injectable({ providedIn: 'root' })
export class PlansSelector {
  @Selector([PlansState])
  static planSummaries(state: IPlanState): PlanSummaryMap {
    return state.planSummaries;
  }
}
